export const SET_VISIT = 'patient/SET_VISIT';

const set_visit = visit_object => ({
  type: SET_VISIT,
  visit_object
});

export default set_visit;
